import { css } from '@emotion/react';
import { theme } from 'styles/theme';
import { H1 } from './H1';
import { ReactNode } from 'react';

export const Heading = ({ title, desc }: { title: string; desc?: string | ReactNode }) => {
	return (
		<div
			css={css`
				margin: 40px 0;
			`}
		>
			<H1>{title}</H1>

			{desc && (
				<div
					css={css`
						font-size: 16px;
						color: ${theme.color.text['300']};
						line-height: 24px;
						margin-top: 4px;
					`}
				>
					{desc}
				</div>
			)}
		</div>
	);
};
